import { render, staticRenderFns } from "./danhSachTraiCay.vue?vue&type=template&id=c89a1bee&scoped=true&"
import script from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
export * from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
import style0 from "./danhSachTraiCay.vue?vue&type=style&index=0&id=c89a1bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a1bee",
  null
  
)

export default component.exports